module.exports = __webpack_public_path__ + "static/cliente4-d4874a272beb34fddf5b33688e87b740.png";